export default {
  login_register: 'Iniciar sesión/Registrarse',
  booking_confirmation_title: 'Confirmación de reserva',
  booking_confirmation_body: 'Gracias por su reserva. A continuación aparecen los detalles de la confirmación.',
  insurance_requirements_modal_disclaimer: `Al hacer esta reserva, confirmo que: No he tenido condenas ni ofensas automovilísticas durante los últimos 5 años. No se ha rechazado una propuesta, se ha cancelado una póliza o se ha rechazado la renovación o se me ha exigido que pague una prima mayor o alguna aseguradora de motores impuso condiciones especiales. No he sido descalificado para conducir. No tengo una acusación o investigación policial pendiente. No tengo ninguna condena por delitos relacionados con robo, fraude o deshonestidad en los últimos 5 años. No he sufrido de visión o audición defectuosa (no corregida por anteojos o audífonos), trastorno cardíaco, diabetes, ataques o alguna enfermedad física o mental de ningún tipo. No he tenido ningún accidente en los últimos 5 años. Haga clic {0} si no cumple con estos requisitos.`,
  insurance_requirements_here: 'aquí',
  insurance_requirements: `He leído y acepto cumplir con los {0}`,
  ir: 'Requisitos Del Seguro',
  location: 'Ubicación',
  pickup_location: 'Ubicación de recogida',
  dropoff_location: 'Ubicación de entrega',
  vehicle: 'Vehículo',
  pickup_and_dropoff: 'Recogida y entrega (hora local)',
  distance_allowance: 'Plus de distancia',
  view_voucher: 'Ver cupón',
  view_more_bookings: 'Ver más reservas',
  identity_verification_body: 'Se le pedirá verificar su identidad antes de recoger el vehículo',
  identity_verification_title: 'Verificar identidad',
  search_again: 'Buscar de nuevo',
  aircon: 'aire acondicionado',
  refrigeration: 'Refrigerado',
  not_available: 'Drive & Go sólo está disponible para personas cuyos documentos de identidad y permisos de conducción sean de determinados países.',
  check_if_included: 'Compruebe si su país está incluido.',
  included_in_booking: 'Incluido en esta reserva',
  cdw_with_excess: 'Exención de daños por colisión con exceso',
  theft_protection: 'Protección antirrobo con exceso',
  risk_reduction: 'Reducción del riesgo',
  free_extras: 'Tiene derecho a dos extras gratuitos <br /> con esta reserva.',
  total_cost: 'Coste total del alquiler',
  continue: 'Continuar',
  luggage_large_short_label: 'L',
  luggage_medium_short_label: 'M',
  luggage_small_short_label: 'S',
  luggage_large_long_label: 'grande',
  luggage_medium_long_label: 'mediano',
  luggage_small_long_label: 'pequeño',
  fuel_unspecified_label: 'sin especificar',
  transmission_manual_label: 'Manual',
  transmission_automatic_label: 'Automático',
  make_a_booking: 'Hacer una reserva',
  pickup_date: 'Fecha de recogida',
  dropoff_date: 'Fecha de entrega',
  driver_age: 'Conductor entre 30 - 65 años',
  enter_driver_age: 'Introduzca la edad del conductor',
  promo_code: 'Código promocional',
  search: 'Buscar',
  dropoff_date_cannot_be_before_pickup_date: 'La fecha de entrega no puede darse antes de la fecha de recogida',
  pickup_date_cannot_be_in_the_past: 'La fecha de recogida no puede estar en el pasado',
  pickup_time_cannot_be_in_the_past: 'La hora de recogida no puede estar en el pasado',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'La hora de entrega debe ser posterior a la de recogida en el mismo día',
  vehicle_filters: 'Filtros del vehículo',
  reset: 'Restablecer',
  transmission: 'Transmisión',
  all: 'Todas',
  manual: 'Manual',
  auto: 'Automática',
  passengers: 'Pasajeros',
  vehicle_type: 'Tipo de vehículo',
  filter: 'Filtrar',
  vehicle_search: 'Búsqueda de vehículo',
  edit: 'Editar',
  no_results: 'Ningún resultado coincide con sus criterios.',
  small_cars: 'Coches pequeños',
  medium_cars: 'Coches medianos',
  large_cars: 'Coches grandes',
  estate_cars: 'Coches familiares',
  suvs: 'Todoterrenos ligeros',
  mpvs: 'Monovolumen',
  vans: 'Furgonetas',
  camper_vans: 'Autocaravanas',
  premium: 'Prémium',
  unspecified: 'sin especificar',
  large: 'grande',
  medium: 'mediano',
  small: 'pequeño',
  automatic: 'automático',
  you_have_been_refunded: 'Se le ha devuelto el dinero.',
  please_customer_service: 'Para hacer una reserva, contacte con nuestro servicio de atención al cliente.',
  contact_customer_service: 'Contactar con el servicio de atención al cliente',
  booking_failed: 'Su reserva no se puede procesar en este momento.',
  summary: 'Resumen',
  reforestation_and_protection: 'Colabore en la reforestación y protección de la pluviselva en Costa Rica',
  cost_of_rental: 'Coste del alquiler',
  to_pay_now: 'A pagar ahora',
  pay_on_arrival: 'A pagar al llegar',
  greenheart_donation: 'Donativo a Green Heart',
  tc_agreement: 'He leído y entiendo los {0}.',
  tc: 'términos y condiciones',
  receive_offers: 'Quiero recibir ofertas especiales por correo electrónico.',
  donate: 'Sí, quiero donar {amount}',
  pay_now: 'Pagar {amount} ahora',
  driver_details: 'Datos del conductor',
  complete_driver_details: 'Complete los datos del conductor.',
  are_you_the_driver: '¿Es usted el conductor?',
  have_an_account: '¿Ya tiene una cuenta?',
  login: 'Iniciar sesión',
  or: 'o',
  first_name: 'Nombre del conductor',
  last_name: 'Apellidos del conductor',
  email: 'Dirección de correo electrónico',
  phone_number: 'Número de teléfono móvil',
  unable_to_save_driver_information: 'No se pudo guardar la información del conductor Inténtelo de nuevo.',
  pay_online_now: 'Pagar en línea ahora',
  day: 'Día',
  choose_location: 'Elegir una ubicación',
  location_not_found: 'Lo sentimos, no hemos podido encontrar la ubicación solicitada.',
  add: 'Agregar',
  remove: 'Quitar',
  free_extra: 'Extra gratis',
  free: '¡GRATIS!',
  fast_track_notice: 'En este servicio se aplican restricciones de origen de documentación. Solo está disponible para personas con documentación de',
  complete_booking: 'Completar reserva',
  choose_card: 'Escoja una tarjeta o añada una nueva.',
  add_billing_details: 'Añada los datos de facturación.',
  card_number: 'Número de tarjeta',
  card_holder_name: 'Titular de la tarjeta',
  card_exp: 'MM / AA',
  card_cvc: 'CVC',
  save_card: '¿Guardar tarjeta?',
  amount_charged: 'Se hará el pago con su tarjeta',
  payment_confirmation: 'Confirmar reserva y pagar',
  payment_methods: 'métodos de pago disponibles',
  use_saved_card: 'x usar tarjeta guardada',
  use_different_card: '+ usar una tarjeta distinta',
  book_now: 'Reservar ahora',
  minimum_age: 'Solo mayores de {age} años',
  excess_liability: 'Extensión de responsabilidad civil',
  security_deposit: 'Depósito de seguridad',
  fuel_policy: 'Política de repostaje',
  like_for_like: 'Equivalente',
  full_to_full: 'Devolución del depósito lleno',
  miles_per_rental: '{mileage} millas gratis por alquiler',
  km_per_rental: '{mileage} km gratis por alquiler',
  unlimited: 'Ilimitado',
  unlimited_mileage: 'Millas ilimitada',
  unlimited_mileage_km: 'Km ilimitados',
  non_amendable: 'No modificable',
  non_refundable: 'No reembolsable',
  free_cancellation_until: 'Cancelación gratuita hasta las',
  cancellation_in_line_with: 'Cancelación acorde con',
  tcs: 'Términos y condiciones',
  free_extras_on_collection: 'Dos extras gratis durante la recogida',
  glass_and_tyres_covered: 'Lunas y neumáticos cubiertos',
  number_of_passengers: 'Número de pasajeros',
  number_of_bags: 'Número de bultos',
  fuel_type: 'Tipo de combustible',
  co2: 'CO2',
  book_type: 'Reservar {type}',
  processing: 'Procesando',
  actual_price: 'Precio real',
  tooltip: 'EL precio en ${currencyCode} es una estimación basada en el cambio de divisa, el precio en ${currency} es vinculante.',
  deposit: 'Depósito',
  pay_online: 'Pagar en línea ahora',
  pay_online_without_extras: 'Precio de alquiler',
  extras_on_arrival: 'Extras a la llegada',
  insurance_on_arrival: 'Reducción del riesgo - Pagar al llegar',
  insurance_online: 'Reducción del riesgo - Pagar ahora',
  extras_online: 'Pagar extras ahora',
  green_heart_donation: 'Donativo a Green Heart',
  aircon_lower: 'aire acondicionado',
  why_use_drive_and_go: '¿Por qué usar Drive & Go?',
  straight_to_car: 'Directo al coche',
  no_queues: 'Sin colas',
  self_checkout: 'Entréguelo usted mismo',
  cant_lose_key: 'La llave no se pierde',
  online_id_check: 'Verificación de identificación en línea',
  phone_as_key: 'El teléfono como llave',
  premiumplus_benefits_includes: 'Beneficios Premium Plus+ también incluidos',
  book_drive_go: 'Reservar Drive & Go',
  duration: 'Duración',
  to_pay_on_arrival: 'A pagar a la llegada',
  return_date: 'Fecha de devolución',
  postcode: 'Código postal',
  country: 'País',
  my_profile: 'Mi perfil',
  additional_options: 'Opciones adicionales',
  booking_details: 'Detalles de la reserva',
  price_for_x_days: 'Precio por {qty_of_days} día | Precio por {qty_of_days} días',
  cancelled: 'Cancelada',
  upcoming: 'Próxima',
  active: 'Activa',
  drive_and_go: {
    drive_and_go: 'Drive And Go',
    available_countries: 'Drive &amp; Go está solo disponible para personas cuyos documentos de identidad y permisos de conducción estén emitidos en los siguientes países:',
    drive_and_go_today: '¡Reserve Drive & Go hoy!',
    drive_and_go_shortened: 'Drive & Go',
    why_use_drive_and_go: '¿Por qué usar Drive & Go?',
    straight_to_car: 'Directo al coche',
    no_queues: 'Sin colas',
    self_checkout: 'Entréguelo usted mismo',
    cannot_lose_the_key: 'La llave no se pierde',
    online_id_check: 'Verificación de identificación en línea',
    phone_as_a_key: 'El teléfono como llave',
    premium_plus_benefits_also_included: 'Beneficios Premium Plus+ también incluidos',
    book_drive_and_go: 'Reservar Drive & Go'
  },
  my_bookings: "Mis reservas",
  no_bookings: "Sin reservas",
  no_bookings_to_display: 'No hay reservas para mostrar.',
  search_great_car_rental_deals: "Search great car rental deals for your next trip.",
  odometer_at_collection: 'Cuentakilómetros en el momento de la recogida',
  fuel_at_collection: 'Combustible en el momento de la recogida',
  start_check_in: 'Comenzar registro',
  start_collection: 'Comenzar recogida',
  recent_bookings: 'Reservas recientes',
  damage: {
    updated_damage_report_submitted: 'Se ha enviado un informe de daños actualizado. Un miembro de nuestro servicio de atención al cliente contactará con usted de ser necesario.',
    add_additional_damage: 'Añadir daño adicional',
    you_may_report_additional_damage_up_to: 'Puede informar de daños adicionales hasta 24 horas después de entregar el vehículo',
    specify_damage: 'Especificar daño',
    please_choose_the_area_and_type_of_damage: 'Elija la zona y el tipo de daño',
    type_of_damage: 'Tipo de daño',
    is_this_more_than_5_cm: '¿Es más de 5 cm?',
    please_take_or_select_a_photo: 'Haga una foto o seleccione una',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Haga una foto para asegurarse de que el daño se vea claramente.',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Si es necesario, puede añadir otra foto; seleccione el icono para añadir otra',
    save_image: 'Guardar imagen',
    save_images: 'Guardar imágenes',
    damage_saved_successfully: 'Daño guardado correctamente',
    add_photo: 'Añadir foto'
  },
  checkout: {
    start_collection: 'Iniciar recogida',
    collect_vehicle: 'Recoger vehículo',
    we_will_let_you_know_the_details: 'Le haremos saber la ubicación y los detalles para que pueda localizar el vehículo de alquiler.',
    inspect: 'Inspeccionar',
    we_will_ask_for_four_photos_from_each_corner: 'Le pediremos cuatro fotos de cada esquina del vehículo junto con cualquier daño nuevo que no esté en la lista.',
    fuel_and_milage: 'Combustible y kilometraje',
    you_confirm_the_readings_at_the_start_of_your_hire: 'Confirme los kilómetros y el combustible al comienzo de su alquiler.',
    sign: 'Firmar',
    sign_the_rental_agreement: 'Firme el contrato de alquiler.',
    away_you_go: 'Vamos allá',
    you_are_free_to_take_to_the_road: '¡Ya puede tomar la carretera!',
    collect_your_vehicle: 'Recoger su vehículo',
    get_directions: 'Obtener indicaciones',
    hide_directions: 'Ocultar indicaciones',
    local_time: 'hora local',
    tel: 'Tel',
    getting_to_the_location: 'Llegar a la ubicación',
    get_vehicle_details: 'Obtener detalles del vehículo',
    view_map: 'Ver mapa',
    unlock_vehicle_and_continue: 'Desbloquear vehículo y continuar',
    unable_to_connect_to_vehicle: 'No se puede conectar con el vehículo',
    we_were_unable_to_connect_to_the_vehicle_please_check: 'No hemos podido conectarnos con el vehículo. Compruebe que está junto al vehículo correcto y vuelva a intentarlo.',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'No hemos podido encontrar la reserva del vehículo. Inténtelo de nuevo más tarde.',
    odometer_and_fuel: 'Cuentakilómetros y combustible',
    odometer: 'Cuentakilómetros',
    please_confirm_the_odometer_and_fuel_readings: 'Si es posible, confirme las lecturas de odómetro y combustible.',
    the_odometer_field_is_required: 'El campo del cuentakilómetros es obligatorio',
    and_must_be_greater_than_the_checkout_odometer: 'y debe ser mayor que el cuentakilómetros de la entrega',
    confirm: 'Confirmar',
    please_take_a_photo_from_each_corner_of_the_vehicle: 'Haga una foto de cada esquina del vehículo.',
    pre_existing_damage: 'Daño preexistente',
    no_pre_existing_damage: 'Sin daños preexistentes.',
    new_damage: 'Nuevo daño',
    add_additional_damage: 'añadir daño adicional',
    no_new_damage_to_report: 'No hay nuevos daños de los que informar',
    checkout_complete: 'Entrega completada',
    start_rental: 'Iniciar alquiler',
    congratulations_name_it_is_time_to_take_to_the_road: 'Enhorabuena, {customer_name}. ¡Es hora de salir a la carretera!',
    we_are_unable_to_complete_your_vehicle_checkout: 'No podemos completar la entrega de su vehículo.',
    please_do_the_following: 'Haga lo siguiente',
    remove_all_belonging_and_lock_the_vehicle: 'Retire sus pertenencias y cierre el vehículo.',
    lock_vehicle: 'Bloquear vehículo',
    once_you_have_contacted_customer_services: 'Cuando haya contactado con el servicio de atención al cliente',
    vehicle_location: 'Ubicación del vehículo',
    collect_your: 'Recoja su',
    from: 'Desde',
    key_in_glove_box: 'su llave se encuentra en la guantera',

    keyholder: {
      not_detected: 'Clave no detectada en el titular de la clave',
      not_detected_please_try_again: 'Coloque su clave en el titular de la clave e intente nuevamente.',

      not_installed: 'Porta llaves no instalado',
      not_installed_please_contact_customer_service: 'El llavero no está instalado, comuníquese con el servicio al cliente.',
    },
    keyring: {
      look_up_failed: 'Llavero buscar fallido',
      look_up_failed_please_contact_customer_service: 'La búsqueda de llavero falló, comuníquese con el servicio al cliente.',
    },
    key: {
      invalid: 'La clave no es válida.',
      invalid_please_contact_customer_service: 'Su clave no es válida, comuníquese con el servicio al cliente.',

      expired: 'La clave ha expirado',
      expired__please_contact_customer_service: 'Su clave ha caducado, comuníquese con el servicio al cliente.',
    }
  },
  checkin: {
    start_check_in: 'Iniciar check-in',
    vehicle_location: 'Ubicación del vehículo',
    tell_us_where_you_have_parked: 'Díganos dónde estacionó el vehículo.',
    fuel_and_milage: 'Combustible y kilometraje',
    you_confirm_the_readings_at_the_end_of_your_hire: 'Confirme los kilómetros y el combustible al final de su alquiler.',
    inspect: 'Inspeccionar',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Le pediremos cuatro fotos de cada esquina del vehículo junto con cualquier daño producido durante el alquiler.',
    lock: 'Bloquear',
    check_you_have_left_no_belonging_then_lock_the_vehicle: 'Compruebe que no se ha dejado nada y bloquee el vehículo.',
    please_tell_us_where_you_have_parked_the_vehicle: 'Díganos dónde estacionó el vehículo.',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Cuando bloquee el vehículo, no podrá volver a desbloquearlo.',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, compruebe que no ha dejado pertenencias, bloquee el vehículo y, si es necesario, devuelva la llave física al titular de la llave.',
    lock_vehicle: 'Bloquear vehículo',
    complete_check_in: 'Registro completado',
    inspection: 'Inspeccionar',
    complete_vehicle_check_in: 'Completar registro del vehículo',
    we_are_unable_to_complete_your_vehicle_check_in: 'No podemos completar el registro de su vehículo.',
    please_contact_customer_services: 'Póngase en contacto con el servicio de atención al cliente.',
    once_you_have_contacted_customer_services: 'Cuando haya contactado con el servicio de atención al cliente',
    please_amend_odometer_to_be_greater_than: 'Modifique el odómetro para que sea mayor que {odometer_value}',
  },
  rental_agreement: {
    rental_agreement: 'Contrato de alquiler',
    agreement_between: 'Contrato entre',
    and: 'y',
    sign_rental_agreement: 'Firmar contrato de alquiler',
    i_have_read_and_understood_the_terms_and_conditions: 'He leído y entendido los términos y condiciones y acepto el estado del vehículo'
  },
  full_insurance_no_deposit: 'Seguro completo y no se requiere depósito',
  excess: '{amount} exceso',
  deposit: '{amount} depósito',
  included_daily_distance: '{distance} {unit} por día',
  miles: 'millas',
  kilometers: 'kilómetros',
  collection_details_title: 'Detalles de la colección',
  collection_details_not_found: 'No hay detalles de colección definidos para esta ubicación',
  free_cancellation: 'Cancelación gratis',
  no_deposit: 'No hay depósito',
  benefit_from: 'Beneficio de',
  for_only_per_day: 'Por solo {price} por día',
  upgrade_mee: 'UpgradeMee'
}